<template>
  <div>
    <h3 style="margin-bottom: 0 !important">
      {{ t('meterDevices.menuTitle') }}
    </h3>

    <!-- <h4>Zähler und Wechselrichter Einstellungen</h4> -->
    <!-- :icon-right="'Arrow'" -->
    <MeterList :devices="devices" :teaser="false" />
    <LinkButton
      style="margin-bottom: 1rem"
      :text="t('meterDevices.scan')"
      :icon-right="'Arrow'"
      :href="setupAssistantUrl"
      target="_blank"
    />
  </div>
</template>

<script setup>
import LinkButton from '@/components/LinkButton.vue';
import MeterList from '@/components/meters/MeterList.vue';
import { useStrings } from '@/composables/useStrings';
import { useAuthStore } from '@/stores/useAuthStore';
import { useCubeStore } from '@/stores/useCubeStore';
import { useDeviceStore } from '@/stores/useDeviceStore';
import { computed } from 'vue';

const { t } = useStrings()
const authStore = useAuthStore()
const cubeStore = useCubeStore()
const deviceStore = useDeviceStore()

const devices = computed(() =>
  deviceStore.devicesList.filter((d) => d.deviceType !== 'myStrom-Wifi-Switch')
)

const setupAssistantUrl = computed(() =>
  authStore.urls.backend + '/installation/eFRIENDSCube/' + cubeStore.iotDeviceId + '/setup'
)
</script>

<style lang="scss">
  .notification-settings,
  .email-notification-settings {
    display: flex;
    justify-content: space-between;
    margin-bottom: spacer(2);
  }

  .icon {
    width: 1em;
    vertical-align: middle;
  }
</style>
